module.exports = __webpack_public_path__ + "static/media/potato-rice.da4408bf.jpg";